module.exports = __webpack_public_path__ + "img/FR22040.123561a7.png";